import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import DashboardPage from "@/pages/DashboardPage";
import WeekPage from "@/pages/WeekPage";
import HistoryPage from "@/pages/HistoryPage";
import ValidationPage from "@/pages/ValidationPage";
import TeamPage from "@/pages/TeamPage";
import EventsPage from "@/pages/EventsPage";
import EventDetailPage from "@/pages/EventDetailPage";
import EquipmentPage from "@/pages/EquipmentPage";
import IntermittentsPage from "@/pages/IntermittentsPage";
import DeclarationsPage from "@/pages/DeclarationsPage";
import ClientsPage from "@/pages/ClientsPage";
import ContactsPage from "@/pages/ContactsPage";
import PlacesPage from "@/pages/PlacesPage";
import ServiceNotesPage from "@/pages/ServiceNotesPage";
import ErrorsPage from "@/pages/ErrorsPage";
import PublicDeclarationForm from "@/pages/PublicDeclarationForm";
import PublicDeclarationRequestForm from "@/pages/PublicDeclarationRequestForm";
import PublicClientPortal from "@/pages/PublicClientPortal";
import { Clock } from "lucide-react";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Clock className="h-6 w-6 text-primary animate-pulse" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/declaration/:token" element={<PublicDeclarationForm />} />
            <Route path="/demande-declaration/:token" element={<PublicDeclarationRequestForm />} />
            <Route path="/portail-client/:token" element={<PublicClientPortal />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route index element={<DashboardPage />} />
              <Route path="/evenements-kanban" element={<EventsPage />} />
              <Route path="/evenements/:id" element={<EventDetailPage />} />
              <Route path="/semaine" element={<WeekPage />} />
              <Route path="/historique" element={<HistoryPage />} />
              <Route path="/evenements" element={<Navigate to="/evenements-kanban" replace />} />
              <Route path="/materiel" element={<EquipmentPage />} />
              <Route path="/declarations" element={<DeclarationsPage />} />
              <Route path="/intermittents" element={<IntermittentsPage />} />
              <Route path="/clients" element={<ClientsPage />} />
              <Route path="/contacts" element={<ContactsPage />} />
              <Route path="/lieux" element={<PlacesPage />} />
              <Route path="/notes-service" element={<ServiceNotesPage />} />
              <Route path="/validation" element={<Protected roles={["manager", "admin"]}><ValidationPage /></Protected>} />
              <Route path="/equipe" element={<Protected roles={["admin"]}><TeamPage /></Protected>} />
              <Route path="/erreurs" element={<Protected roles={["admin"]}><ErrorsPage /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
